import { DSGrow, DSPaper, DSPopper } from '@deltasierra/components';
import * as React from 'react';
import styled from 'styled-components';
import { PlannerItemThumbnail } from './PlannerItemThumbnail';

const StyledPaperContainer = styled(DSPaper)({
    borderRadius: 0,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 200,
    maxWidth: 150,
    overflow: 'hidden',
    position: 'relative',
});

const StyledTitleBar = styled.div({
    fontSize: 11,
    fontWeight: 500,
    padding: 1,
    textAlign: 'center',
});

type PlannerItemThumbnailPopperProps = {
    anchorEl: HTMLElement | null;
    open: boolean;
    thumbnailTitle: string;
    thumbnailUrl: string;
};

export function PlannerItemThumbnailPopper({
    anchorEl,
    open,
    thumbnailTitle,
    thumbnailUrl,
}: PlannerItemThumbnailPopperProps): JSX.Element {
    return (
        <DSPopper
            anchorEl={anchorEl}
            open={open}
            placement="top"
            transition
        >
            {({ TransitionProps }) => (
                <DSGrow {...TransitionProps}>
                    <StyledPaperContainer elevation={3}>
                        <PlannerItemThumbnail thumbnailUrl={thumbnailUrl} />
                        <StyledTitleBar>{thumbnailTitle}</StyledTitleBar>
                    </StyledPaperContainer>
                </DSGrow>
            )}
        </DSPopper>
    );
}
PlannerItemThumbnailPopper.displayName = 'PlannerItemThumbnailPopper';
